import { Badge } from '@ayble-health/dashboard-components';
import useUser from '../../../api/healthCoach/useUser';
import { AppOnboardingStatus } from '../../../models/user';
import { formatDate } from '../utils';
import OverviewCard from './OverviewCard';

const APP_STATUS_COLORS: Record<
  AppOnboardingStatus,
  { bg: string; text: string }
> = {
  [AppOnboardingStatus.NeverLoggedIn]: { bg: 'robin', text: 'aqua' },
  [AppOnboardingStatus.Onboarding]: { bg: 'shortbread', text: 'warning.fg' },
  [AppOnboardingStatus.BaselineComplete]: { bg: 'green.100', text: 'grass' },
};
const DEFAULT_APP_STATUS_COLORS = { bg: 'blush', text: 'seafoam' };

export const GutCheckCountCard = () => {
  const {
    user: {
      amount_completed_gut_checks,
      last_gut_check,
      app_onboarding_status,
    } = {},
    isLoading,
  } = useUser();

  const { bg: appStatusBg, text: appStatusText } =
    (app_onboarding_status && APP_STATUS_COLORS[app_onboarding_status]) ||
    DEFAULT_APP_STATUS_COLORS;

  return (
    <OverviewCard
      title={'Total Gut Checks'}
      text={amount_completed_gut_checks}
      bottomTag={{
        text: `Last survey: ${formatDate(
          last_gut_check || undefined,
          'MMM D'
        )}`,
        icon: (
          <Badge
            bgColor={appStatusBg}
            borderColor={'cloud.200'}
            borderWidth={1}
            rounded={'full'}
            px={2}
            py={1}
            color={appStatusText} fontSize={'xs'} fontWeight={'bold'}
          >
            {app_onboarding_status || 'N/A'}
          </Badge>
        ),
      }}
      flexGrow={3}
      loading={isLoading}
      h={'120px'}
    />
  );
};

export default GutCheckCountCard;
